import { render, staticRenderFns } from "./plus-34.vue?vue&type=template&id=039641ca&scoped=true"
import script from "./plus-34.vue?vue&type=script&lang=js"
export * from "./plus-34.vue?vue&type=script&lang=js"
import style0 from "./plus-34.vue?vue&type=style&index=0&id=039641ca&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039641ca",
  null
  
)

export default component.exports